module.exports = __webpack_public_path__ + "img/mariana.1514e849.png";